document.addEventListener("DOMContentLoaded", function () {
  // 🚫 Don't run translations on English pages under /en/...
  const isEnglish = location.pathname.split("/").includes("en");
  if (isEnglish) return;

  /** @type {{ [key: string]: string }} */
  const translations = {
    "BUTTON:select setting": "Tovább a gyémántokhoz",
    "SPAN:select setting": "Stílus kiválasztása",
    "select setting": "Tovább a gyémántokhoz",
    "add diamond": "Gyémánt kiválasztása",
    "complete ring": "Készítsd el a gyűrűt",
    "price": "Ár",
    "style": "Stílus",
    "shape": "Gyémánt csiszolása",
    "metal": "Ékszer anyaga",
    "more shapes": "Több csiszolás mutatása",
    "fewer shapes": "Kevesebb csiszolás mutatása",
    "description": "Termék leírás",
    "colour": "Szín",
    "carats": "Karát",
    "clarity": "Tisztaság",
    "table": "Tábla",
    "fluoresence": "Fluoreszencia",
    "certificate": "Tanúsítvány",
    "polish": "Fényezés",
    "labgrown type": "Labgrown típus",
    "no results found": "Nincs találat",
    "results": "Találatok",
    "advanced filters": "Több szűrő",
    "list": "Lista",
    "grid": "Csempék",
    "price: low to high": "Ár: kicsitől nagyig",
    "price: high to low": "Ár: nagytól kicsiig",
    "carat: low to high": "Karát: kicsitől nagyig",
    "sort": "Rendezés",
    "review": "Áttekintés",
    "total": "Összesen",
    "adding to cart": "",
    "Add to cart": "Kosárba teszem",
    "ring style": "Gyűrű fazonja",
    "Advanced Filters": "Több szűrő",
    "setting only": "Gyűrű sín",
    "back to browse": "Vissza a gyűrűkhöz",
    "ring size": "Gyűrű méret",
    "diamond shape": "Gyémánt csiszolása",
    "14k white gold": "14K Fehér arany",
    "14k yellow gold": "14K Sárga arany",
    "18k white gold": "18K Fehér arany",
    "18k yellow gold": "18K Sárga arany",
    "1. choose a": "1. Válassz egy",
    "2. choose a": "2. Válassz egy",
    "3. complete your": "3. Készítsd el a",
    "3. complete ring": "Készítsd el a gyűrűd",
    "diamond": "gyémántot",
    "setting": "gyűrűsínt",
    "remove": "Eltávolítás",
    "ring": "gyűrűd",
    "your ring summary": "Összegzés",
    "view": "Megnézem",
    "finger size": "Gyűrű méret",
    "not sure": "Nem tudom",
    "choose a": "Válassz egy",
    "complete your": "Készítsd el a",
    "select diamond": "Ezt a gyémántot választom",
    "about this diamond": "Erről a gyémántról",
    "Diamond details": "A gyémánt tulajdonságai",
    "Price only for diamond": "Az ár csak a gyémántra vonatkozik",
    "Click to view certificate": "Kattints ide a certifikációhoz",
    "Certificate Number": "Certifikáció száma",
    "Back to browse": "Vissza",
    "Loading...": "Betöltés ...",
    "Europe 52.50 will be used.": "",
    "Price only for Setting": "Az ár csak a gyűrűsínre vonatkozik",
    "This price is for the Setting only": "Az ár csak a gyűrűsínre vonatkozik",

    "A flawless diamond has no visible imperfections or inclusions under 10x magnification. These diamonds are extremely rare and highly valued for their purity and brilliance.": "A Flawless gyémánt 10x nagyítás alatt sem mutat látható zárványt vagy hibát. Ezek a gyémántok extrém ritkák, ezért a legmagasabb árkategóriába tartoznak. Tisztaságuk és ragyogásuk miatt kiemelten értékesek.",

    "These diamonds have no internal inclusions but may have tiny surface blemishes. To the naked eye, they look just as perfect as flawless diamonds but are slightly more common.": "Az IF gyémántokban nincs belső zárvány, viszont előfordulhatnak apró, felületi jellegzetességek. Szabad szemmel ugyanúgy tökéletesnek látszanak, mint a Flawless gyémántok, csak gyakoribbak.",

    "These diamonds have minuscule inclusions that are extremely difficult to see, even under magnification. They are nearly flawless and offer exceptional clarity.": "A VVS tisztaságú gyémántokban rendkívül apró zárványok találhatók, amelyeket még nagyítással is nehéz észrevenni. Ezek a gyémántok szinte hibátlannak számítanak, és kiváló tisztaságot biztosítanak",

    "These diamonds have small inclusions that are only visible under magnification and remain nearly invisible to the naked eye. They offer a great balance between quality and value.": "Ezekben a gyémántokban vannak apró zárványok, de általában csak nagyító alatt látszanak. Szabad szemmel szinte mindig “tiszta”, zárványmentes hatásúak.",

    "These diamonds contain inclusions that are more noticeable under magnification and may sometimes be visible to the naked eye. However, they still maintain good brilliance and can be a great option for budget-conscious buyers.":
      "Az Included gyémántokban a zárványok már szabad szemmel is észrevehetők lehetnek. Ezek hatással lehetnek az átlátszóságra és a csillogásra.",

    "These diamonds have noticeable inclusions that may affect transparency and brilliance. While they are the most affordable, the inclusions can sometimes impact durability and sparkle.":
      "Az Included gyémántokban a zárványok már szabad szemmel is észrevehetők lehetnek. Ezek hatással lehetnek az átlátszóságra és a csillogásra.",

    "Similar to excellent, ideal-cut diamonds are precisely cut to reflect almost all light, maximizing brightness and fire. They are typically found in premium cuts like round brilliant diamonds": "Az egyik legjobb csiszolás. A gyémánt szinte az összes beérkező fényt visszaveri, ezért nagyon erősen csillog és 'tüzes' hatású.",
    "Diamonds with an excellent cut reflect nearly all light that enters them, resulting in maximum brilliance and sparkle. This is one of the highest cut grades, ensuring outstanding beauty.": "Szinte maximális csillogás és ragyogás. A fényt nagyon hatékonyan veri vissza, ezért látványra kiemelkedő.",
    "These diamonds reflect most of the light that enters them, offering great brilliance and fire but slightly less than excellent or ideal cuts. They are still a fantastic choice with a lower price point.": "Nagyon szépen csillog, a fény nagy részét visszaveri. Tüze mérsékeltebben látványos, mint az Excellent vagy az Ideal csiszolás.",
    "A good-cut diamond reflects a fair amount of light but lacks the superior brilliance of higher grades. It can still appear beautiful, but some light leakage reduces overall sparkle.": "Érezhetően kevesebb fényt ver vissza, ezért kevésbé “szikrázik”. A magasabb minőségekhez képest több fény szökhet ki a gyémántból ami csökkenti a csillogást.",
    "These diamonds allow more light to escape through the sides and bottom rather than reflecting it back. As a result, they have noticeably less brilliance and sparkle.": "Több fény távozik oldalra és lefelé is, ahelyett hogy visszaverődne, emiatt a gyémánt láthatóan kevésbé ragyog és kevésbé csillog.",
    "Diamonds in this category lose most of their light, appearing dull or lifeless. They are generally not recommended if brilliance and beauty are a priority.": "A fény nagy részét elveszíti, ezért mattabb, “élettelenebb” hatású lehet."



  };

  const forbiddenMaterials = ["950 platinum", "9k white gold", "9k yellow gold"];

  function translateTextInComponent() {
    let container = document.querySelector('div[data-component="ring-builder"]');
    if (!container) {
      container = document.querySelector("#diamond-proxy-root");
    }
    if (!container) return;

    // Process elements that might contain text nodes to be joined
    const elements = container.querySelectorAll(
      "div, span, p, h1, h2, h3, h4, h5, h6, a, button"
    );

    elements.forEach((element) => {
      // 🚫 NEW RULE: if node has a parent/ancestor with this class, do not translate it
      if (element.closest(".diamond-properties-wrapper")) {
        return;
      }

      // If element has element children, skip it, as we only want to process
      // elements that are direct parents of text nodes.
      if (element.children.length > 0) {
        return;
      }

      // Also check if it has been part of an already translated parent
      // if (element.closest('[data-translated="true"]')) {
      //   return;
      // }

      const originalText = element.textContent || "";
      if (originalText.trim() === "") {
        return;
      }

      const trimmedText = originalText.trim();
      const lowerTrimmedText = trimmedText.toLowerCase();
      const lowerOriginalText = originalText.toLowerCase();
      const tagName = element.tagName;

      const contextualKeyTrimmedLower = `${tagName}:${lowerTrimmedText}`;
      const contextualKeyOriginalLower = `${tagName}:${lowerOriginalText}`;
      const contextualKeyOriginal = `${tagName}:${originalText}`;

      let translated =
        translations[contextualKeyOriginal] ||
        translations[originalText] ||
        translations[contextualKeyOriginalLower] ||
        translations[lowerOriginalText] ||
        translations[contextualKeyTrimmedLower] ||
        translations[lowerTrimmedText];

      if (translated) {
        element.textContent = translated;
        // element.setAttribute("data-translated", "true");

        // Add price note next to "Ár"
        if (translated.toLowerCase() === "ár") {
          const parentDiv = element.closest("div");
          if (parentDiv && !parentDiv.querySelector("small[data-price-note]")) {
            const small = document.createElement("small");
            small.setAttribute("data-price-note", "true");
            small.textContent =
              "- A feltüntetett ár az ÁFÁ-t tartalmazza.";
            small.style.marginLeft = "15px";
            small.style.maxWidth = "200px";
            small.style.fontSize = "9pt";
            parentDiv.appendChild(small);
          }
        }
      }
    });

    // // After each run, clean up the markers to allow for re-translation if content changes.
    // const translatedElements = container.querySelectorAll('[data-translated="true"]');
    // translatedElements.forEach((el) => el.removeAttribute("data-translated"));

    return true;
  }

  // 🔧 Replace only the text node inside matching divs (not the whole div content)
  function handleSpecialRingSizeDivs() {
    let container = document.querySelector('div[data-component="ring-builder"]');
    if (!container) {
      container = document.querySelector("#diamond-proxy-root");
    }
    if (!container) return;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue && node.nodeValue.includes("If you don't know the ring size")) {
        node.nodeValue =
          "Ha nem tudod a pontos gyűrűméretet, válaszd a 'Not sure' opciót, és automatikusan az európai 52.50-es standard méretben készítjük el. Ha a méret mégsem lenne megfelelő, a gyűrűt díjmentesen, egyszeri alkalommal pontos méretre igazítjuk.";
      }
      if (node.nodeValue && node.nodeValue.includes("Europe 52.50 will be")) {
        node.nodeValue =
          "";
      }
    }
  }

  function removeForbiddenShapeItems() {
    let container = document.querySelector('div[data-component="ring-builder"]');
    if (!container) {
      container = document.querySelector("#diamond-proxy-root");
    }
    if (!container) return;

    const items = container.querySelectorAll(".filter-shape-item");
    items.forEach((item) => {
      const span = item.querySelector("span");
      const text = span ? span.textContent.toLowerCase().trim() : "";
      if (forbiddenMaterials.includes(text)) {
        console.log("now removing node", item);
        // item.remove();
      }
    });
  }

  // 🔧 Replace "Add to cart" button text
  function replaceAddToCartButton() {
    // let container = document.querySelector('div[data-component="ring-builder"]');
    // if (!container) {
    //   container = document.querySelector("#diamond-proxy-root");
    // }
    // if (!container) return;

    // const buttons = container.querySelectorAll("button");
    // buttons.forEach((btn) => {
    //   const txt = (btn.innerText || "").trim();
    //   if (txt === "Add to cart") {
    //     btn.innerText = "Kosárba helyezem";
    //   }
    // });
  }

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  async function startWhenSuccessful() {
    // let success = false;

    // while (!success) {
    //   try {
    //     console.log('translating')
    //     const result = translateTextInComponent();
    //     console.log('translating result', result)
    //     // removeForbiddenShapeItems();

    //     // decide what "success" means
    //     success = Boolean(result);

    //     if (!success) {
    //       await sleep(1000);
    //     }
    //   } catch (err) {
    //     console.error("Retrying after error:", err);
    //     await sleep(1000);
    //   }
    // }

    // success → start polling
    const pollTranslations = setInterval(translateTextInComponent, 200);
    const pollRingSizeDivs = setInterval(handleSpecialRingSizeDivs, 500);
    const pollForbiddenShapes = setInterval(removeForbiddenShapeItems, 500);
    const pollAddToCart = setInterval(replaceAddToCartButton, 500);

    // stop everything after 5 minutes
    setTimeout(() => {
      clearInterval(pollTranslations);
      clearInterval(pollRingSizeDivs);
      clearInterval(pollForbiddenShapes);
      clearInterval(pollAddToCart);
    }, 300000);
  }

  // kick it off
  startWhenSuccessful();
});